import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M79.9399 65.25C78.1199 60.12 76.6299 54.49 76.2999 32.96C75.9699 11.43 70.1699 1.5 70.1699 1.5H12.5599C12.5599 1.5 6.75993 11.44 6.42993 32.96C6.09993 54.49 4.60991 60.12 2.78991 65.25C0.969911 70.38 -1.18008 81.48 10.7399 88.1C10.7399 88.1 10.1099 85.6699 10.4099 84.2899C11.9299 85.6699 13.95 87.3899 18.03 86.2799C20.91 85.4999 23.2799 82.47 25.7199 79.48C28.1999 81.79 33.9799 84.4399 40.9999 84.4399C48.0199 84.4399 54.0499 82.0499 57.0599 79.5299C59.4899 82.4999 61.88 85.3999 64.71 86.2799C68.08 87.3299 71.38 85.3399 72.3299 84.2899C72.7899 86.0799 71.9999 88.1 71.9999 88.1C83.9099 81.47 81.7599 70.38 79.9399 65.25Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M65.7 3.47998C65.7 3.47998 72.4899 15.73 72.4899 32.96C72.4899 50.18 72.4899 57.3 74.4799 65.25C76.4699 73.2 76.26 83.28 68.58 86.09"
        stroke={outline}
        strokeMiterlimit="10"
      />
      <path
        d="M63.0498 4.79993C63.0498 4.79993 67.2498 13.22 67.7498 26.14C68.2498 39.06 66.5098 48.8499 70.0098 61.7699C73.1198 73.2499 72.1598 88.0999 63.8798 85.7799"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M51.9698 12.2799C51.9698 12.2799 49.9098 26.8 54.7898 40.76C60.9198 58.31 63.2398 75.87 54.9598 80.5"
        stroke={outline}
        strokeMiterlimit="10"
      />
      <path
        d="M51.81 16.26C51.81 16.26 47.17 35.19 51.81 50.59C56.99 67.78 54.85 79.12 49.74 82.26"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M17.03 3.47998C17.03 3.47998 10.2399 15.73 10.2399 32.96C10.2399 50.18 10.2399 57.3 8.24995 65.25C6.25995 73.2 7.02994 83.94 13.9899 86.09"
        stroke={outline}
        strokeMiterlimit="10"
      />
      <path
        d="M19.6799 4.79993C19.6799 4.79993 15.3999 12.81 14.8999 25.72C14.3999 38.64 15.8099 48.67 12.7199 61.76C9.98989 73.34 10.5699 88.0899 18.8499 85.7699"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M26.4699 14.08C26.4699 14.08 28.5299 28.5999 23.6499 42.5599C17.5199 60.1099 15.1999 77.6699 23.4799 82.2999"
        stroke={outline}
        strokeMiterlimit="10"
      />
      <path
        d="M29.1199 16.3999C29.1199 16.3999 34.1799 35.33 29.5499 50.73C24.3699 67.92 27.3799 79.06 33.0099 81.71"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
    </g>
  )
}
